import { ComponentType, memo } from "react";
import { FallbackProps } from "react-error-boundary";
import { Box, Typography } from "@material-ui/core";

interface ExtendedError extends Error {
  cause?: unknown;
}

export const ErrorFallback: ComponentType<FallbackProps> = memo(({ error }) => {
  const extendedError = error as ExtendedError;

  return (
    <Box
      height="100dvh"
      width="100dvw"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
    >
      <Box mb={3} maxWidth={600}>
        <Typography variant="h1" color="primary" align="center">
          Error {error.name}
        </Typography>
      </Box>
      <Box mb={3} maxWidth={600}>
        <Typography variant="h4" color="secondary" align="center">
          {error.message}
        </Typography>
      </Box>

      {extendedError.cause && (
        <Box>
          <Typography variant="subtitle1" align="center">
            Server response
          </Typography>

          <Typography align="center">
            {typeof extendedError.cause === "object"
              ? JSON.stringify(extendedError.cause)
              : String(extendedError.cause)}
          </Typography>
        </Box>
      )}
    </Box>
  );
});
